export default {
    currentUser: null,
    currentLang: 'it',
    defaultLang: 'it',
    loggedSSO: false,
};
